import _Concerns from './component';
import _routes from './routes';

export const Concerns = _Concerns;
export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/Concerns/index.js